import React from 'react';

const Agri = () => {
  return (
    <div style={{
      minHeight: '60vh',
      background: 'linear-gradient(135deg, #f7fee7 0%, #ecfccb 100%)',
      padding: '2rem 1rem',
    }}>
      <div className="page-wrapper">
        <div className="page-hero">
          <h1>🌾 Agriculture</h1>
          <p>Learn modern and traditional farming techniques.</p>
        </div>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '0.5rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '2rem',
        }}>
          <p>Agriculture content will be rendered here</p>
        </div>
      </div>
    </div>
  );
};

export default Agri;
